import React from 'react';
import { Text } from '../Text';
import { classes, st, vars } from './TimelineItem.st.css';
import { dataHooks } from './Timeline.constants';

import { isString } from '../utils/StringUtils';
import { TimelineItemProps } from './TimelineItem.types';

/** A timeline item is a display of a timeline event */
function TimelineItem({
  idx,
  item,
  dataHook,
  gap,
  skin = 'dark',
}: TimelineItemProps) {
  const { customPrefix, suffix, label, labelAction, line = 'filled' } = item;

  return (
    <li className={st(classes.event, { skin })} data-hook={dataHook}>
      <>
        <div className={classes.prefix}>
          {customPrefix ? (
            <div data-hook={`${dataHooks.timelineBulletIndicator}-${idx}`}>
              {customPrefix}
            </div>
          ) : (
            <div
              data-hook={`${dataHooks.timelineDefaultPrefix}-${idx}`}
              className={classes.defaultIndicator}
            />
          )}
          <div className={st(classes.line, { line })} />
        </div>
        <div
          className={st(classes.label, { withSuffix: !!suffix })}
          style={{ [vars.marginBottom]: gap }}
        >
          {isString(label) ? (
            <Text
              dataHook={`${dataHooks.timelineLabel}-${idx}`}
              weight="thin"
              size="small"
              className={classes.labelText}
            >
              {label}
            </Text>
          ) : (
            label
          )}
          {labelAction ? (
            <div
              className={classes.labelAction}
              data-hook={`${dataHooks.timelineLabelAction}-${idx}`}
            >
              {labelAction}
            </div>
          ) : null}
        </div>
        {suffix ? (
          <div
            className={classes.suffix}
            data-hook={`${dataHooks.timelineSuffix}-${idx}`}
          >
            {isString(suffix) ? (
              <Text
                dataHook={`${dataHooks.timelineTextSuffix}-${idx}`}
                weight="thin"
                light
                secondary
                size="small"
              >
                {suffix}
              </Text>
            ) : (
              suffix
            )}
          </div>
        ) : null}
      </>
    </li>
  );
}

TimelineItem.displayName = 'TimelineItem';

export { TimelineItem };
